export const experienceData = [
    {
        id: 1,
        company: 'Realware LLC ',
        jobtitle: 'Fullstack Developer',
        startYear: 'Feb-2022',
        endYear: 'present'
    },
    {
        id: 2,
        company: 'Adanian Labs ',
        jobtitle: 'Frontend Developer',
        startYear: 'Oct 2022',
        endYear: 'sep 2023'
    },
    {
        id: 3,
        company: 'Genesis 1O ',
        jobtitle: 'Fullstack Developer',
        startYear: 'Oct 2022',
        endYear: '2023'
    },
    {
        id: 4,
        company: 'ABNO Softwares International ',
        jobtitle: 'Fullstack Developer',
        startYear: 'Oct 2020',
        endYear: 'Oct 2022'
    },
    {
        id: 5,
        company: 'United States Of Africa ',
        jobtitle: 'Front-end Developer',
        startYear: 'May 2022',
        endYear: 'present'
    },
    {
        id: 6,
        company: 'Softtek ',
        jobtitle: 'Wordpress Developer',
        startYear: 'March 2020',
        endYear: 'Nov 2022'
    },
    {
        id: 7,
        company: 'bdtask',
        jobtitle: 'Frontend Web Developer',
        startYear: 'March 2019',
        endYear: 'Sept 2021'
    },
    {
        id: 8,
        company: 'ZUCA Solutions Limited',
        jobtitle: 'Android Developer',
        startYear: 'Apr 2018',
        endYear: 'March 2020'
    },
   
    
]
export const experienceDataTwo = [
     {
        id: 5,
        company: 'United States Of Africa ',
        jobtitle: 'Front-end Developer',
        startYear: 'May 2022',
        endYear: 'present'
    },
    {
        id: 6,
        company: 'Softtek ',
        jobtitle: 'Wordpress Developer',
        startYear: 'March 2020',
        endYear: 'Nov 2022'
    },
    {
        id: 7,
        company: 'bdtask',
        jobtitle: 'Frontend Web Developer',
        startYear: 'March 2019',
        endYear: 'Sept 2021'
    },
    {
        id: 8,
        company: 'ZUCA Solutions Limited',
        jobtitle: 'Android Developer',
        startYear: 'Apr 2017',
        endYear: 'March 2020'
    },
]